import { render, staticRenderFns } from "./ChannelProductListAssociationLimitReqView.vue?vue&type=template&id=126e82f4&scoped=true&"
import script from "./ChannelProductListAssociationLimitReqView.vue?vue&type=script&lang=js&"
export * from "./ChannelProductListAssociationLimitReqView.vue?vue&type=script&lang=js&"
import style0 from "./ChannelProductListAssociationLimitReqView.vue?vue&type=style&index=0&id=126e82f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e82f4",
  null
  
)

export default component.exports